// extracted by mini-css-extract-plugin
module.exports = {"title":"TrdCntFeatures_title__AZucM"};